import React from 'react';

interface IPersonSilhouetteProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

const PersonSilhouette: React.FC<IPersonSilhouetteProps> = props => (
  <svg width="17px" height="18px" viewBox="0 0 17 18" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-244.000000, -161.000000)"
        fill={props.fill || Styles.color.black}
        fillRule="nonzero"
      >
        <g transform="translate(245.000000, 161.000000)">
          <path
            d="M7.5,0.5 C5.290861,0.5 3.5,2.290861 3.5,4.5 C3.5,6.709139 5.290861,8.5 7.5,8.5 C9.709139,8.5 11.5,6.709139 11.5,4.5 C11.5,2.290861 9.709139,0.5 7.5,0.5 Z M7.5,1.5 C9.15685425,1.5 10.5,2.84314575 10.5,4.5 C10.5,6.15685425 9.15685425,7.5 7.5,7.5 C5.84314575,7.5 4.5,6.15685425 4.5,4.5 C4.5,2.84314575 5.84314575,1.5 7.5,1.5 Z"
            id="Oval"
          />
          <path
            d="M10.8333333,9.5 C13.3377904,9.5 15.3834781,11.452871 15.4951949,13.9061724 L15.5,14.1176471 L15.5,17 C15.5,17.2761424 15.2761424,17.5 15,17.5 C14.7545401,17.5 14.5503916,17.3231248 14.5080557,17.0898756 L14.5,17 L14.5,14.1176471 C14.5,12.1854167 12.9638127,10.6049721 11.0281854,10.5050186 L10.8333333,10.5 L4.16666667,10.5 C2.20567315,10.5 0.606227959,12.0181145 0.505078523,13.9256384 L0.5,14.1176471 L0.5,17 C0.5,17.2761424 0.276142375,17.5 0,17.5 C-0.245459889,17.5 -0.44960837,17.3231248 -0.491944331,17.0898756 L-0.5,17 L-0.5,14.1176471 C-0.5,11.6369353 1.47611945,9.61515563 3.95315684,9.50474867 L4.16666667,9.5 L10.8333333,9.5 Z"
            id="Path"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default PersonSilhouette;
